import { render, staticRenderFns } from "./BwinBanner.vue?vue&type=template&id=8a30ee44"
import script from "./BwinBanner.vue?vue&type=script&lang=js"
export * from "./BwinBanner.vue?vue&type=script&lang=js"
import style0 from "./BwinBanner.vue?vue&type=style&index=0&id=8a30ee44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports